import axios from "axios";
import { getToken } from "./getToken";

export const getApiBaseUrl = (env = process.env) =>
  env.NODE_ENV === "production"
    ? env.REACT_APP_BASE_PRODUCTION_URL
    : env.REACT_APP_BASE_LOCAL_URL || env.REACT_APP_BASE_PRODUCTION_URL;

const http = axios.create({
  baseURL: getApiBaseUrl(),
  // timeout: 30000,
  // withCredentials: true,
});

// Change request data/error here
http.interceptors.request.use(
  (config) => {
    const token = getToken();
    config.headers = token
      ? {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        }
      : {
          ...config.headers,
        };

    return config;
  },
  (error) => {
    return error;
  }
);

export default http;
